<template>
  <ts-modal
    ref="modal"
    modal-title="Edit questions"
  >
    <template #modal-content>
      <div class="card">
        <div
          v-if="questions.length == 0"
          class="card-body text-muted"
        >
          No questions found
        </div>
        <sortable
          :list="questions"
          item-key="id"
          :options="{draggable: '.list-group-item', handle: '.sort-handle', animation: 150}"
          class="list-group list-group-flush"
          @end="updateQuestionOrder"
        >
          <template #item="{element: question}">
            <div class="list-group-item">
              <div class="row gx-2">
                <div class="col-auto">
                  <span
                    class="glyphicons sortable sort-handle"
                    title="Drag to reorder items"
                  />
                </div>
                <div class="col">
                  <div class="form-check">
                    <input
                      :id="`q-${question.id}`"
                      v-model="question.enabled"
                      type="checkbox"
                      class="form-check-input"
                    >
                    <label
                      class="form-check-label"
                      :for="`q-${question.id}`"
                    >
                      {{ question.nr }}. {{ question.name }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </sortable>
      </div>
    </template>
    <template #modal-footer>
      <button
        type="button"
        class="btn btn-sm btn-secondary"
        data-bs-dismiss="modal"
      >
        Close
      </button>
      <button
        type="button"
        class="btn btn-sm btn-primary"
        @click="saveQuestions"
      >
        Ok
      </button>
    </template>
  </ts-modal>
</template>
<script setup lang="ts">
import {ref, useTemplateRef} from "vue"
import {Sortable} from "sortablejs-vue3"
import type {SortableEvent} from "sortablejs"
import type {SurveyReportQuestion} from "./survey-types"
import {sortSortableList} from "@/js/js-utils"
import TsModal from "@/js/vue-components/ts-modal.vue";

const emit = defineEmits<{
  save: [questions: SurveyReportQuestion[]]
}>()

const modal = useTemplateRef<InstanceType<typeof TsModal>>("modal")
const questions = ref<SurveyReportQuestion[]>([])

const showModal = (incomingQuestions: SurveyReportQuestion[]): void => {
  questions.value = JSON.parse(JSON.stringify(incomingQuestions))
  modal.value?.show()
}

const hideModal = (): void => {
  modal.value?.hide()
}

const saveQuestions = (): void => {
  emit("save", questions.value)
}

const updateQuestionOrder = (event: SortableEvent): void => {
  sortSortableList(questions.value, event)
}

defineExpose({
  hideModal,
  showModal,
})
</script>
